/** Hindi: mentors for people new to a city. */
export const mentor = {
    "mentor.city.bengaluru": "बेंगलुरु",
    "mentor.offer_about": "नए लोग आपका पहला नाम, काम, भाषाएँ, इलाक़ा और आपके अपने गिने हुए काम देखते हैं। आपका फ़ोन नंबर कभी नहीं।",
    "mentor.listed": "{city} में नए लोग आपको ढूँढ सकते हैं।",
    "mentor.find": "मेंटर ढूँढें",
    "mentor.find_about": "कोई जो कुछ समय से {city} में काम कर रहा है और आपको रास्ता दिखा सकता है। किससे पूछना है, आप चुनते हैं। आपके लिए कोई और नहीं चुनता।",
    "mentor.safety_title": "किसी से मिलने से पहले",
    "mentor.safety_public": "सार्वजनिक जगह पर मिलें।",
    "mentor.safety_money": "मेंटर के ज़रिए काम या कमरे के लिए कभी किसी को पैसे न दें।",
    "mentor.safety_report": "जो पैसे या काग़ज़ात माँगे, उसकी रिपोर्ट करें।",
    "mentor.safety_ok": "मैं समझ गया/गई",
    "mentor.woman_ask": "क्या आप महिला हैं? यह आपके फ़ोन पर ही रहता है। इससे आप सिर्फ़ महिला मेंटर चुन सकती हैं।",
    "mentor.yes": "हाँ",
    "mentor.no": "नहीं",
    "mentor.women_only": "सिर्फ़ महिला मेंटर",
    "mentor.trade": "काम",
    "mentor.lang": "भाषा",
    "mentor.search": "मेंटर दिखाएँ",
    "mentor.says": "कहते हैं {months} महीनों में {jobs} काम",
    "mentor.own_count": "यह उनके अपने फ़ोन की गिनती है।",
    "mentor.vouched": "{name} ने भरोसा जताया है",
    "mentor.choose": "{name} को चुनें",
    "mentor.chosen": "चुना गया",
    "mentor.max": "आप एक साथ {count} लोगों से पूछ सकते हैं।",
    "mentor.none": "अभी कोई मेंटर नहीं",
    "mentor.none_women": "{city} में अभी कोई महिला मेंटर नहीं। आप “सिर्फ़ महिला मेंटर” बंद कर सकती हैं।",
    "mentor.none_intro": "किसी जान-पहचान वाले से पूछें — जिस घर में आपने काम किया, या अपने मेंटर से — कि क्या वे {city} में किसी को जानते हैं।",
    "mentor.helplines": "सेव करने के लिए नंबर",
    "mentor.ask.one": "{count} मेंटर से पूछें",
    "mentor.ask.other": "{count} मेंटर से पूछें",
    "mentor.arrival": "आप किस हफ़्ते पहुँचेंगे",
    "mentor.area_near": "किस इलाक़े के पास रहेंगे (अगर पता हो)",
    "mentor.note": "छोटा सा संदेश (चाहें तो)",
    "mentor.send": "भेजें",
    "mentor.sent": "पूछ लिया। उनके जवाब यहाँ दिखेंगे।",
    "mentor.too_old": "{name} को पहले GigSync अपडेट करना होगा।",
    "mentor.offers": "मेंटर जो आपकी मदद कर सकते हैं",
    "mentor.your_requests": "आपके अनुरोध",
    "mentor.waiting": "{name} का इंतज़ार…",
    "mentor.declined": "{name} अभी मदद नहीं कर सकते।",
    "mentor.closed": "बंद",
    "mentor.offered": "{name} आपकी मदद कर सकते हैं।",
    "mentor.accept_offer": "{name} को स्वीकार करें",
    "mentor.accept_help": "फिर आप 30 दिन तक एक-दूसरे को संदेश भेज सकते हैं। कोई भी इसे आगे बढ़ा सकता है।",
    "mentor.cancel": "रद्द करें",
    "mentor.linked": "अब आप और {name} 30 दिन तक एक-दूसरे को संदेश भेज सकते हैं।",
    "mentor.requests": "मदद माँगते नए लोग",
    "mentor.request_line": "{name} {trade} के काम के लिए {city} आ रहे हैं, {date} वाले हफ़्ते में पहुँचेंगे।",
    "mentor.request_near": "{area} के पास रहेंगे।",
    "mentor.speaks": "भाषा: {langs}",
    "mentor.help": "{name} की मदद करें",
    "mentor.not_now": "अभी नहीं",
    "mentor.offer_note": "उनके लिए छोटा सा संदेश (चाहें तो)",
    "mentor.chip": "मेंटर",
    "mentor.chip_newcomer": "शहर में नए",
    "mentor.days_left.one": "{count} दिन बाक़ी",
    "mentor.days_left.other": "{count} दिन बाक़ी",
    "mentor.renew": "30 दिन और बढ़ाएँ",
    "mentor.renewed": "30 दिन और खुला है।",
    "mentor.block": "ब्लॉक करें",
    "mentor.block_confirm": "{name} को ब्लॉक करें? वे इस फ़ोन पर कहीं नहीं दिखेंगे, और GigSync आपको फिर नहीं मिलाएगा।",
    "mentor.blocked": "{name} ब्लॉक हैं।",
    "mentor.report": "रिपोर्ट करें",
    "mentor.report_title": "{name} की रिपोर्ट करें",
    "mentor.reason.asked_money": "मुझसे पैसे माँगे",
    "mentor.reason.asked_documents": "मेरे काग़ज़ात माँगे",
    "mentor.reason.unsafe": "मुझे असुरक्षित महसूस कराया",
    "mentor.reason.rude": "बदतमीज़ी की",
    "mentor.reason.other": "कुछ और",
    "mentor.report_send": "रिपोर्ट भेजें",
    "mentor.reported": "धन्यवाद। GigSync इसे देखेगा।",
    "mentor.intro_ask": "क्या आप {city} में किसी को जानते हैं?",
    "mentor.intro_ask_note": "मैं {city} जा रहा/रही हूँ। क्या आप वहाँ किसी को जानते हैं जो मुझे जमने में मदद कर सके?",
    "mentor.intro_asked": "आपने {name} से पूछा।",
    "mentor.introduce": "{name} को किसी से मिलवाएँ",
    "mentor.intro_pick": "{name} को {city} में किससे मिलना चाहिए?",
    "mentor.intro_send": "{name} से मिलवाएँ",
    "mentor.intro_sent": "आपने {name} और {other} को मिलवाया।",
    "mentor.intro_none": "आप उन्हीं को मिलवा सकते हैं जिनके साथ आपने किसी काम पर दस्तख़त किए, या जिनसे मेंटर के रूप में जुड़े रहे।",
    "mentor.intro_got_mentor": "{by} चाहते हैं कि आप {name} से मिलें, जो {city} में काम करते हैं और आपकी मदद कर सकते हैं।",
    "mentor.intro_got_newcomer": "{by} चाहते हैं कि आप {name} से मिलें, जो {city} आ रहे हैं और जिन्हें आपकी मदद चाहिए।",
    "mentor.intro_meet": "{name} से मिलें",
    "mentor.intro_no": "नहीं, धन्यवाद",
    "mentor.intro_waiting": "{name} की हाँ का इंतज़ार…",
    "mentor.intros": "मुलाक़ातें",
    "mentor.links": "मेंटर से जुड़ाव",
    "mentor.links_about": "आपके मेंटर और जिनकी आप मदद करते हैं। जुड़ाव 30 दिन चलता है, जब तक आप में से कोई उसे आगे न बढ़ाए।",
    "mentor.unread.one": "{count} नया संदेश",
    "mentor.unread.other": "{count} नए संदेश",
    "mentor.placeholder": "{name} को संदेश",
    "mentor.thread_empty": "{name} को नमस्ते कहें।",
    "mentor.end": "जुड़ाव ख़त्म करें",
    "mentor.end_confirm": "{name} से जुड़ाव ख़त्म करें? उनके साथ के संदेश इस फ़ोन से मिट जाएँगे।",
    "mentor.ask_person": "{name} से पूछें",
    "mentor.no_people": "अभी कोई नहीं। जिनके साथ आप किसी काम पर दस्तख़त करें, या मेंटर के रूप में जुड़ें, वे यहाँ दिखेंगे।",
};
//# sourceMappingURL=mentor.js.map